import { Typography } from 'antd';
import { TitleDivider } from '../divider/style/TitleDivider';

export interface PdfElementPreviewProps {
  /** Testo del segnaposto mostrato nell'editor */
  title: string;
}

/**
 * Preview (solo lato editor) condivisa dai widget grafici renderizzati
 * esclusivamente nel PDF e non visibili in compilazione.
 */
export function PdfElementPreview(props: PdfElementPreviewProps) {
  return (
    <TitleDivider>
      <div>{props.title}</div>
      <Typography.Text>
        Questo elemento non è visibile in compilazione.
      </Typography.Text>
    </TitleDivider>
  );
}
